import {
  CustomConditionModel,
  SpecialConditionData,
  SpecialConditionDataConditionType,
} from '@urbanx/agx.campaigns.client'

export const updateModelOnCustomCondition = (
  model: CustomConditionModel,
  customCondition: SpecialConditionData
): SpecialConditionData => {
  if (
    !model ||
    customCondition.conditionType !== SpecialConditionDataConditionType.Custom
  )
    return customCondition

  const updatedSpecialCondition: SpecialConditionData = {
    ...customCondition,
    customCondition: {
      ...model,
    },
  }

  return updatedSpecialCondition
}
